import React from "react";
import { Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Componente reutilizável de botão com ícone
const InviteButton = ({
  isCopied = false, // Indica se o link já foi copiado
  onClick,
  text = "COPIAR LINK", // Texto padrão do botão
  copiedText = "COPIADO", // Texto quando o link já foi copiado
  className = "",
  sx = {},
  icon, // Ícone padrão (antes de copiar)
  iconActive, // Ícone quando já foi copiado
}) => {
  return (
    <Button
      variant="outlined"
      className={isCopied ? `${className} active` : className} // Adiciona classe "active" se foi copiado
      onClick={onClick}
       sx={{
        ...sx,
      }}
      // Define o ícone à esquerda do texto
      startIcon={
        isCopied ? ( // Se já foi copiado, mostra o ícone ativo
          iconActive ? (
            <FontAwesomeIcon icon={iconActive} />
          ) : null
        ) : icon ? ( // Caso contrário, mostra o ícone padrão (se tiver)
          <FontAwesomeIcon icon={icon} />
        ) : null
      }
    >
      {isCopied ? copiedText : text} {/* Mostra "COPIADO" ou "COPIAR LINK" */}
    </Button>
  );
};

export default InviteButton;
